<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Customer Payments</span>
            <div>
                <el-button class="white-btn" size="small" @click="add2()">Add Refund</el-button>
                <el-button v-if="!hasFlight && !hasPackageSection" class="ml-2 white-btn" size="small" @click="addPayment()">Add Payment</el-button>
                <el-button v-if="hasPackageSection" class="ml-2 white-btn" size="small" @click="addPackagePayment()">Add Package Payment</el-button>
                <el-button v-if="hasFlight" class="ml-2 white-btn" size="small" @click="addFlightPayment()">Add Flight Payment</el-button>
            </div>
        </template>

        <!-- Flight Payments Section -->
        <template v-if="hasFlight">
            <p style="font-weight:600;font-size:13px;margin:0 0 6px">Flight Payments</p>
            <el-descriptions size="small" border :column="3" class="mb-2">
                <el-descriptions-item label="Flight Pricing">{{ fmt(flightPricing) }}</el-descriptions-item>
                <el-descriptions-item label="Received">{{ fmt(flightPaid) }}</el-descriptions-item>
                <el-descriptions-item label="Remaining">
                    <span :style="{color: flightRemaining < 0 ? '#f56c6c' : '#67c23a', fontWeight:'600'}">{{ fmt(flightRemaining) }}</span>
                </el-descriptions-item>
            </el-descriptions>
            <el-row v-if="flightPayments.length > 0">
                <el-col>
                    <el-table size="small" :data="flightPayments" border style="width:100%">
                        <el-table-column label="#" width="40"><template #default="scope">{{ scope.$index+1 }}</template></el-table-column>
                        <el-table-column prop="received_on" label="Received On" />
                        <el-table-column label="Amount"><template #default="scope">{{ fmt(scope.row.amount) }}</template></el-table-column>
                        <el-table-column label="GST (18% on profit)"><template #default="scope">{{ fmt(scope.row.amount_gst) }}</template></el-table-column>
                        <el-table-column label="Base (ex-GST)"><template #default="scope">{{ fmt(scope.row.amount_without_gst) }}</template></el-table-column>
                        <el-table-column prop="payment_source" label="Source" />
                        <el-table-column prop="received_by" label="Received By" />
                        <el-table-column label="Status">
                            <template #default="scope">
                                <el-tag type="info" v-if="scope.row.payment_status=='Pending'">Pending</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.payment_status=='Inprogress'">Inprogress</el-tag>
                                <el-tag type="success" v-else-if="scope.row.payment_status=='Received'">Received</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="Attachment">
                            <template #default="scope">
                                <el-link class="mr-2" type="primary" v-if="scope.row.attachment!=null" @click="viewfile(scope.row.attachment.link)">View File</el-link>
                                <el-button type="info" size="small" @click="addattachment(scope.row.id)"><el-icon><Link /></el-icon></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="Action" fixed="right" width="100">
                            <template #default="scope">
                                <el-button v-if="scope.row.editable" type="primary" size="small" @click="editpayment(scope.row)"><el-icon><Edit /></el-icon></el-button>
                                <el-button v-if="scope.row.editable" type="danger" size="small" @click="deletepayment(scope.row)"><el-icon><Delete /></el-icon></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <p v-else style="font-size:12px;color:#909399;padding:4px 0;margin:0">No flight payments recorded yet.</p>
        </template>

        <!-- Package Payments Section -->
        <template v-if="hasPackageSection">
            <p style="font-weight:600;font-size:13px;margin:10px 0 6px">Package Payments</p>
            <el-descriptions size="small" border :column="hasTcs ? 4 : 3" class="mb-2">
                <el-descriptions-item label="Package Pricing">{{ fmt(packagePricing) }}</el-descriptions-item>
                <el-descriptions-item v-if="hasTcs" label="TCS (2%) Included">{{ fmt(tcsInPricing) }}</el-descriptions-item>
                <el-descriptions-item label="Received">{{ fmt(packagePaid) }}</el-descriptions-item>
                <el-descriptions-item label="Remaining">
                    <span :style="{color: packageRemaining < 0 ? '#f56c6c' : '#67c23a', fontWeight:'600'}">{{ fmt(packageRemaining) }}</span>
                </el-descriptions-item>
            </el-descriptions>
            <el-row v-if="packagePayments.length > 0">
                <el-col>
                    <el-table size="small" :data="packagePayments" border style="width:100%">
                        <el-table-column label="#" width="40"><template #default="scope">{{ scope.$index+1 }}</template></el-table-column>
                        <el-table-column prop="received_on" label="Received On" />
                        <el-table-column label="Amount"><template #default="scope">{{ fmt(scope.row.amount) }}</template></el-table-column>
                        <el-table-column v-if="hasTcs" label="TCS (2%)"><template #default="scope">{{ fmt(scope.row.tcs) }}</template></el-table-column>
                        <el-table-column label="GST (5%)"><template #default="scope">{{ fmt(scope.row.amount_gst) }}</template></el-table-column>
                        <el-table-column label="Base (ex-GST)"><template #default="scope">{{ fmt(scope.row.amount_without_gst) }}</template></el-table-column>
                        <el-table-column prop="payment_source" label="Source" />
                        <el-table-column prop="received_by" label="Received By" />
                        <el-table-column label="Status">
                            <template #default="scope">
                                <el-tag type="info" v-if="scope.row.payment_status=='Pending'">Pending</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.payment_status=='Inprogress'">Inprogress</el-tag>
                                <el-tag type="success" v-else-if="scope.row.payment_status=='Received'">Received</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="Attachment">
                            <template #default="scope">
                                <el-link class="mr-2" type="primary" v-if="scope.row.attachment!=null" @click="viewfile(scope.row.attachment.link)">View File</el-link>
                                <el-button type="info" size="small" @click="addattachment(scope.row.id)"><el-icon><Link /></el-icon></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="Action" fixed="right" width="100">
                            <template #default="scope">
                                <el-button v-if="scope.row.editable" type="primary" size="small" @click="editpayment(scope.row)"><el-icon><Edit /></el-icon></el-button>
                                <el-button v-if="scope.row.editable" type="danger" size="small" @click="deletepayment(scope.row)"><el-icon><Delete /></el-icon></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <p v-else style="font-size:12px;color:#909399;padding:4px 0;margin:0">No package payments recorded yet.</p>
        </template>

        <!-- Fallback: no finalquotation - single generic table -->
        <template v-if="!hasFlight && !hasPackageSection">
            <el-row v-if="enquiry.customerpayments.length>0">
                <el-col>
                    <el-table size="small" :data="enquiry.customerpayments" border style="width:100%">
                        <el-table-column label="#" width="40"><template #default="scope">{{ scope.$index+1 }}</template></el-table-column>
                        <el-table-column prop="received_on" label="Received On" />
                        <el-table-column label="Amount"><template #default="scope">{{ fmt(scope.row.amount) }}</template></el-table-column>
                        <el-table-column prop="payment_source" label="Source" />
                        <el-table-column prop="received_by" label="Received By" />
                        <el-table-column label="Status">
                            <template #default="scope">
                                <el-tag type="info" v-if="scope.row.payment_status=='Pending'">Pending</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.payment_status=='Inprogress'">Inprogress</el-tag>
                                <el-tag type="success" v-else-if="scope.row.payment_status=='Received'">Received</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="Attachment">
                            <template #default="scope">
                                <el-link class="mr-2" type="primary" v-if="scope.row.attachment!=null" @click="viewfile(scope.row.attachment.link)">View File</el-link>
                                <el-button type="info" size="small" @click="addattachment(scope.row.id)"><el-icon><Link /></el-icon></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="Action" fixed="right" width="100">
                            <template #default="scope">
                                <el-button v-if="scope.row.editable" type="primary" size="small" @click="editpayment(scope.row)"><el-icon><Edit /></el-icon></el-button>
                                <el-button v-if="scope.row.editable" type="danger" size="small" @click="deletepayment(scope.row)"><el-icon><Delete /></el-icon></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </template>

        <!-- Customer Refunds -->
        <el-row class="mt-2" v-if="enquiry.customerrefundpayments.length>0">
            <el-col>
                <p style="font-weight:600;font-size:13px;margin:0 0 6px">Customer Refunds</p>
                <el-table size="small" :data="enquiry.customerrefundpayments" border style="width: 100%">
                    <el-table-column label="#" width="40"><template #default="scope">{{ scope.$index+1 }}</template></el-table-column>
                    <el-table-column prop="paid_on" label="Paid On" />
                    <el-table-column label="Amount"><template #default="scope">{{ fmt(scope.row.amount) }}</template></el-table-column>
                    <el-table-column prop="payment_source" label="Source" />
                    <el-table-column prop="paid_by" label="Paid By" />
                    <el-table-column label="Status">
                        <template #default="scope">
                            <el-tag type="info" v-if="scope.row.payment_status=='Pending'">Pending</el-tag>
                            <el-tag type="warning" v-else-if="scope.row.payment_status=='Inprogress'">Inprogress</el-tag>
                            <el-tag type="success" v-else-if="scope.row.payment_status=='Paid'">Paid</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="Attachment">
                        <template #default="scope">
                            <el-link class="mr-2" type="primary" v-if="scope.row.attachment!=null" @click="viewfile(scope.row.attachment.link)">View File</el-link>
                            <el-button type="info" size="small" @click="addattachment2(scope.row.id)"><el-icon><Link /></el-icon></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payment_details" label="Details" />
                    <el-table-column label="Action" fixed="right" width="100">
                        <template #default="scope">
                            <el-button v-if="scope.row.editable" type="primary" size="small" @click="editpayment2(scope.row)"><el-icon><Edit /></el-icon></el-button>
                            <el-button v-if="scope.row.editable" type="danger" size="small" @click="deletepayment2(scope.row)"><el-icon><Delete /></el-icon></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </el-card>

    <el-dialog v-model="dialogDelete" title="Delete Payment?" width="500">
        <p>Received On : {{ deletePayment.received_on }}</p>
        <p>Amount : {{ fmt(deletePayment.amount) }}</p>
        <p>Source : {{ deletePayment.payment_source }}</p>
        <p>Received By : {{ deletePayment.received_by }}</p>
        <p>Status : {{ deletePayment.payment_status }}</p>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" :disabled="deleting" @click="dialogDelete = false">Cancel</el-button>
                <el-button type="primary" :disabled="deleting" :loading="deleting" @click="deletepaymentsubmit()">Confirm</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog v-model="dialogDelete2" title="Delete Refund?" width="500">
        <p>Paid On : {{ deletePayment2.paid_on }}</p>
        <p>Amount : {{ fmt(deletePayment2.amount) }}</p>
        <p>Source : {{ deletePayment2.payment_source }}</p>
        <p>Paid By : {{ deletePayment2.paid_by }}</p>
        <p>Status : {{ deletePayment2.payment_status }}</p>
        <p>Details : {{ deletePayment2.payment_details }}</p>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" :disabled="deleting2" @click="dialogDelete2 = false">Cancel</el-button>
                <el-button type="primary" :disabled="deleting2" :loading="deleting2" @click="deletepaymentsubmit2()">Confirm</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- Add / Edit Payment Drawer -->
    <el-drawer v-model="dialogAdd" direction="rtl">
        <template #header>
            <h4>{{ paymentform.is_flight == 1 ? 'Flight Payment' : 'Package Payment' }}</h4>
        </template>
        <template #default>
            <el-form ref="paymentruleFormRef" :model="paymentform" status-icon :rules="paymentrules" label-width="auto" label-position="top">

                <!-- Pricing summary in drawer -->
                <el-descriptions v-if="paymentform.is_flight == 1" size="small" border :column="3" class="mb-3">
                    <el-descriptions-item label="Flight Total">{{ fmt(flightPricing) }}</el-descriptions-item>
                    <el-descriptions-item label="Already Paid">{{ fmt(flightPaidExcludingEdit) }}</el-descriptions-item>
                    <el-descriptions-item label="Remaining">
                        <span :style="{color: flightMaxPayable <= 0 ? '#f56c6c' : '#67c23a', fontWeight:'600'}">{{ fmt(flightMaxPayable) }}</span>
                    </el-descriptions-item>
                </el-descriptions>
                <el-descriptions v-else size="small" border :column="3" class="mb-3">
                    <el-descriptions-item label="Package Total">{{ fmt(packagePricing) }}</el-descriptions-item>
                    <el-descriptions-item label="Already Paid">{{ fmt(packagePaidExcludingEdit) }}</el-descriptions-item>
                    <el-descriptions-item label="Remaining">
                        <span :style="{color: packageMaxPayable <= 0 ? '#f56c6c' : '#67c23a', fontWeight:'600'}">{{ fmt(packageMaxPayable) }}</span>
                    </el-descriptions-item>
                </el-descriptions>

                <el-form-item label="Amount" prop="amount">
                    <el-input type="number" min="0" v-model="paymentform.amount" />
                    <div style="font-size:11px;color:#909399;margin-top:2px">Max payable: {{ fmt(currentMaxPayable) }}</div>
                </el-form-item>

                <!-- Live GST Breakdown Preview -->
                <el-card v-if="parseFloat(paymentform.amount) > 0" class="mb-3" shadow="never" style="background:#f8f9fa;border:1px solid #e4e7ed;font-size:12px">
                    <template v-if="paymentform.is_flight == 1">
                        <div style="font-weight:600;margin-bottom:4px">Flight GST Breakdown</div>
                        <div>Flight Cost (no GST): <b>{{ fmt(flightCostBase) }}</b></div>
                        <div>Profit Portion: <b>{{ fmt(flightGstPreview.profit_portion) }}</b></div>
                        <div>GST (18% on profit): <b>{{ fmt(flightGstPreview.gst) }}</b></div>
                        <div>Base of profit (ex-GST): <b>{{ fmt(flightGstPreview.base) }}</b></div>
                    </template>
                    <template v-else>
                        <div style="font-weight:600;margin-bottom:4px">Package GST Breakdown</div>
                        <div v-if="hasTcs">TCS (2%): <b>{{ fmt(packageGstPreview.tcs) }}</b></div>
                        <div v-if="hasTcs">After TCS Base: <b>{{ fmt(packageGstPreview.base_after_tcs) }}</b></div>
                        <div>GST (5%): <b>{{ fmt(packageGstPreview.gst) }}</b></div>
                        <div>Base (ex-GST): <b>{{ fmt(packageGstPreview.base) }}</b></div>
                    </template>
                </el-card>

                <el-form-item label="Payment Status" prop="payment_status">
                    <el-select style="width:100%" v-model="paymentform.payment_status">
                        <el-option label="Pending" value="Pending"></el-option>
                        <el-option label="Inprogress" value="Inprogress"></el-option>
                        <el-option label="Received" value="Received" :disabled="authuser.department!='Account'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payment Source" prop="payment_source">
                    <el-select style="width:100%" v-model="paymentform.payment_source">
                        <el-option label="Online" value="Online"></el-option>
                        <el-option label="Cash" value="Cash"></el-option>
                        <el-option label="Cheque" value="Cheque"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Received By" prop="received_by">
                    <el-input v-model="paymentform.received_by" />
                </el-form-item>
                <el-form-item label="Received On" prop="received_on">
                    <el-date-picker type="date" style="width:100%" v-model="paymentform.received_on" format="DD-MM-YYYY" value-format="YYYY-MM-DD" />
                </el-form-item>
            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogAdd=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()" :loading="loading1" :disabled="loading1">Submit</el-button>
            </div>
        </template>
    </el-drawer>

    <el-drawer v-model="dialogAttachment" direction="rtl">
        <template #header><h4>Payment Attachment</h4></template>
        <template #default>
            <el-form ref="attachmentruleFormRef" :model="attachmentform" status-icon :rules="attachmentrules" label-width="auto" label-position="top">
                <img v-if="attachmentform.imagedata!=''" :src="attachmentform.imagedata" style="width: 100%">
                <el-form-item label="Attachment" prop="imagedata">
                    <textarea class="form-control mt-2" @paste="pasteImage" placeholder="Paste Image Here"></textarea>
                </el-form-item>
            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogAttachment=false">Cancel</el-button>
                <el-button type="primary" @click="submitPAForm()" :loading="uploading" :disabled="uploading">Upload</el-button>
            </div>
        </template>
    </el-drawer>

    <el-drawer v-model="dialogAdd2" direction="rtl">
        <template #header><h4>Customer Refund</h4></template>
        <template #default>
            <el-form ref="paymentruleFormRef2" :model="paymentform2" status-icon :rules="paymentrules2" label-width="auto" label-position="top">
                <el-form-item label="Amount" prop="amount">
                    <el-input type="number" v-model="paymentform2.amount" />
                </el-form-item>
                <el-form-item label="Payment Status" prop="payment_status">
                    <el-select style="width:100%" v-model="paymentform2.payment_status">
                        <el-option label="Pending" value="Pending"></el-option>
                        <el-option label="Inprogress" value="Inprogress"></el-option>
                        <el-option label="Paid" value="Paid" :disabled="authuser.department!='Account'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payment Source" prop="payment_source">
                    <el-select style="width:100%" v-model="paymentform2.payment_source">
                        <el-option label="Online" value="Online"></el-option>
                        <el-option label="Cash" value="Cash"></el-option>
                        <el-option label="Cheque" value="Cheque"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Paid By" prop="paid_by">
                    <el-input v-model="paymentform2.paid_by" />
                </el-form-item>
                <el-form-item label="Paid On" prop="paid_on">
                    <el-date-picker type="date" style="width:100%" v-model="paymentform2.paid_on" format="DD-MM-YYYY" value-format="YYYY-MM-DD" />
                </el-form-item>
                <el-form-item label="Details" prop="payment_details">
                    <el-input type="textarea" v-model="paymentform2.payment_details" />
                </el-form-item>
            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogAdd2=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm2()" :loading="loading2" :disabled="loading2">Submit</el-button>
            </div>
        </template>
    </el-drawer>

    <el-drawer v-model="dialogAttachment2" direction="rtl">
        <template #header><h4>Refund Attachment</h4></template>
        <template #default>
            <el-form ref="attachmentruleFormRef2" :model="attachmentform2" status-icon :rules="attachmentrules2" label-width="auto" label-position="top">
                <img v-if="attachmentform2.imagedata!=''" :src="attachmentform2.imagedata" style="width: 100%">
                <el-form-item label="Attachment" prop="imagedata">
                    <textarea class="form-control mt-2" @paste="pasteImage2" placeholder="Paste Image Here"></textarea>
                </el-form-item>
            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogAttachment2=false">Cancel</el-button>
                <el-button type="primary" @click="submitPAForm2()" :loading="uploading2" :disabled="uploading2">Upload</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElDescriptions, ElDescriptionsItem,
    ElDatePicker, ElSelect, ElOption, ElLink, ElTag, ElIcon,
    ElTable, ElTableColumn, ElRow, ElCol, ElCard,
    ElDialog, ElButton, ElDrawer, ElForm, ElFormItem, ElInput
} from 'element-plus'
import { Link, Edit, Delete } from '@element-plus/icons-vue'
import moment from "moment";

export default {
    name: "CustomerPayments",
    props: {
        enquiry: { type: Object, default() { return null } },
        authuser: { type: Object, default() { return null } }
    },
    emits: ["saved"],
    components: {
        ElDescriptions, ElDescriptionsItem,
        ElDatePicker, ElSelect, ElOption, Link, ElLink, ElTag, Delete, ElIcon, Edit,
        ElTable, ElTableColumn, ElRow, ElCol, ElCard,
        ElDialog, ElButton, ElForm, ElDrawer, ElFormItem, ElInput
    },
    data() {
        return {
            dialogAttachment: false, uploading: false,
            dialogAdd: false, loading1: false,
            dialogAttachment2: false, uploading2: false,
            dialogAdd2: false, loading2: false,
            deletePayment: null, deleting: false, dialogDelete: false,
            deletePayment2: null, deleting2: false, dialogDelete2: false,
            paymentform: {
                payment_id: '', amount: '', payment_status: '',
                payment_source: '', received_by: '', received_on: '', is_flight: 0,
            },
            paymentrules: {
                amount: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                payment_status: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                payment_source: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                received_by: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                received_on: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
            },
            attachmentform: { payment_id: '', imagedata: '' },
            attachmentrules: { imagedata: [{ required: true, message: 'Required', trigger: ['blur','change'] }] },
            paymentform2: {
                payment_id: '', amount: '', payment_status: '',
                payment_source: '', paid_by: '', paid_on: '', payment_details: ''
            },
            paymentrules2: {
                amount: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                payment_status: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                payment_source: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                paid_by: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
                paid_on: [{ required: true, message: 'Required', trigger: ['blur','change'] }],
            },
            attachmentform2: { payment_id: '', imagedata: '' },
            attachmentrules2: { imagedata: [{ required: true, message: 'Required', trigger: ['blur','change'] }] }
        }
    },
    computed: {
        hasFlight() {
            return !!(this.enquiry.is_flight || (this.enquiry.finalquotation && this.enquiry.finalquotation.flight_includes));
        },
        hasPackageSection() {
            const q = this.enquiry.finalquotation;
            const e = this.enquiry;
            return !!(e.is_hotel || e.is_visa || e.is_landpackage || e.is_cruise || e.is_insurance
                || (q && (q.hotel_includes || q.is_visa || q.is_landpackage || q.is_cruise || q.is_insurance)));
        },
        hasTcs() {
            const bd = this.enquiry.bookingdetails;
            return bd ? parseFloat(bd.tds_cost || 0) > 0 : false;
        },
        tcsInPricing() {
            const bd = this.enquiry.bookingdetails;
            return bd ? parseFloat(bd.tds_cost || 0) : 0;
        },
        flightCostBase() {
            const bd = this.enquiry.bookingdetails;
            return bd ? parseFloat(bd.flight_cost || 0) : 0;
        },
        flightPricing() {
            const bd = this.enquiry.bookingdetails;
            if (!bd) return 0;
            return parseFloat(bd.flight_cost || 0) + parseFloat(bd.flight_gst || 0) + parseFloat(bd.flight_profit || 0);
        },
        packagePricing() {
            const bd = this.enquiry.bookingdetails;
            if (!bd) return 0;
            return parseFloat(bd.hotel_cost || 0) + parseFloat(bd.visa_cost || 0)
                 + parseFloat(bd.land_cost || 0) + parseFloat(bd.cruise_cost || 0)
                 + parseFloat(bd.travel_insurance_cost || 0) + parseFloat(bd.land_profit || 0)
                 + parseFloat(bd.land_gst || 0) + parseFloat(bd.tds_cost || 0);
        },
        flightPayments() {
            return this.enquiry.customerpayments.filter(p => parseInt(p.is_flight) === 1);
        },
        packagePayments() {
            return this.enquiry.customerpayments.filter(p => parseInt(p.is_flight) !== 1);
        },
        flightPaid() {
            return this.flightPayments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
        },
        packagePaid() {
            return this.packagePayments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
        },
        flightRemaining() { return this.flightPricing - this.flightPaid; },
        packageRemaining() { return this.packagePricing - this.packagePaid; },
        flightPaidExcludingEdit() {
            if (!this.paymentform.payment_id) return this.flightPaid;
            const c = this.flightPayments.find(p => p.id == this.paymentform.payment_id);
            return this.flightPaid - (c ? parseFloat(c.amount || 0) : 0);
        },
        packagePaidExcludingEdit() {
            if (!this.paymentform.payment_id) return this.packagePaid;
            const c = this.packagePayments.find(p => p.id == this.paymentform.payment_id);
            return this.packagePaid - (c ? parseFloat(c.amount || 0) : 0);
        },
        flightMaxPayable() { return this.flightPricing - this.flightPaidExcludingEdit; },
        packageMaxPayable() { return this.packagePricing - this.packagePaidExcludingEdit; },
        currentMaxPayable() {
            return this.paymentform.is_flight == 1 ? this.flightMaxPayable : this.packageMaxPayable;
        },
        flightGstPreview() {
            const amount = parseFloat(this.paymentform.amount) || 0;
            const profit_portion = Math.max(0, amount - this.flightCostBase);
            return { profit_portion, gst: profit_portion * 18 / 118, base: profit_portion * 100 / 118 };
        },
        packageGstPreview() {
            const amount = parseFloat(this.paymentform.amount) || 0;
            if (this.hasTcs) {
                const base_after_tcs = amount * 100 / 102;
                return { tcs: amount * 2 / 102, base_after_tcs, gst: base_after_tcs * 5 / 105, base: base_after_tcs * 100 / 105 };
            }
            return { tcs: 0, base_after_tcs: amount, gst: amount * 5 / 105, base: amount * 100 / 105 };
        },
    },
    methods: {
        fmt(val) {
            return Intl.NumberFormat('en-IN').format(Math.round((parseFloat(val) || 0) * 100) / 100);
        },
        addFlightPayment() { this.resetPaymentForm(1); this.dialogAdd = true; },
        addPackagePayment() { this.resetPaymentForm(0); this.dialogAdd = true; },
        addPayment() { this.resetPaymentForm(0); this.dialogAdd = true; },
        resetPaymentForm(is_flight) {
            this.paymentform.is_flight = is_flight;
            this.paymentform.payment_id = '';
            this.paymentform.amount = '';
            this.paymentform.payment_status = '';
            this.paymentform.payment_source = '';
            this.paymentform.received_by = '';
            this.paymentform.received_on = '';
        },
        add2() {
            this.dialogAdd2 = true;
            this.paymentform2.paid_on = ''; this.paymentform2.paid_by = '';
            this.paymentform2.payment_details = ''; this.paymentform2.amount = '';
            this.paymentform2.payment_source = ''; this.paymentform2.payment_status = '';
            this.paymentform2.payment_id = '';
        },
        viewfile(link) { window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight); },
        submitForm() {
            const formEl = this.$refs.paymentruleFormRef;
            if (!formEl) return;
            formEl.validate((valid) => {
                if (valid) {
                    const amount = parseFloat(this.paymentform.amount) || 0;
                    const max = this.currentMaxPayable;
                    if (max > 0 && amount > max + 0.01) {
                        toastr.error('Amount ' + this.fmt(amount) + ' exceeds the remaining payable: ' + this.fmt(max));
                        return;
                    }
                    this.submitpayment();
                }
            });
        },
        submitpayment() {
            let currentObj = this;
            currentObj.loading1 = true;
            axios.post('/enquiry/addcustomerpayment?id='+this.enquiry.id, this.paymentform).then(function (response) {
                toastr.success('Payment Saved Successfully.');
                currentObj.$emit("saved");
                currentObj.resetPaymentForm(currentObj.paymentform.is_flight);
                currentObj.loading1 = false;
                currentObj.dialogAdd = false;
            }).catch(function (error) {
                if (error.response && error.response.status == "404") { toastr.error(error.response.data); }
                else { toastr.error('Something wrong, try again.'); }
                currentObj.loading1 = false;
            });
        },
        addattachment(id) { this.attachmentform.payment_id = id; this.attachmentform.imagedata = ''; this.dialogAttachment = true; },
        pasteImage(pasteEvent) {
            const items = pasteEvent.clipboardData && pasteEvent.clipboardData.items;
            if (!items) return;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf("image") === -1) continue;
                this.addImageCustomerPayment(items[i].getAsFile());
            }
        },
        addImageCustomerPayment(file) {
            if (!file || !file.type.match('image.*')) return;
            const reader = new FileReader();
            reader.onloadend = () => { this.attachmentform.imagedata = reader.result; };
            reader.readAsDataURL(file);
        },
        submitPAForm() {
            const formEl = this.$refs.attachmentruleFormRef;
            if (!formEl) return;
            formEl.validate((valid) => { if (valid) this.uploaddocument(); });
        },
        uploaddocument() {
            let currentObj = this;
            axios.post('/enquiry/addcustomerpaymentattachment?id='+this.enquiry.id, this.attachmentform).then(function () {
                toastr.success('Attachment Saved Successfully.');
                currentObj.$emit("saved");
                currentObj.uploading = false; currentObj.dialogAttachment = false;
            }).catch(function () { toastr.error('Something wrong, try again.'); currentObj.uploading = false; });
        },
        editpayment(temppayment) {
            this.paymentform.received_on = moment(temppayment.received_on, "DD-MM-YYYY").format('YYYY-MM-DD');
            this.paymentform.received_by = temppayment.received_by;
            this.paymentform.amount = temppayment.amount;
            this.paymentform.payment_source = temppayment.payment_source;
            this.paymentform.payment_status = temppayment.payment_status;
            this.paymentform.payment_id = temppayment.id;
            this.paymentform.is_flight = parseInt(temppayment.is_flight) || 0;
            this.dialogAdd = true;
        },
        deletepayment(payment) { this.deletePayment = payment; this.dialogDelete = true; },
        deletepaymentsubmit() {
            let currentObj = this;
            currentObj.deleting = true;
            axios.post('/enquiry/deletecustomerpayment', { id: this.deletePayment.id }).then(function () {
                toastr.success('Payment Deleted Successfully.');
                currentObj.$emit("saved"); currentObj.deleting = false; currentObj.dialogDelete = false;
            }).catch(function () { toastr.error('Something wrong, try again.'); currentObj.deleting = false; });
        },
        submitForm2() {
            const formEl = this.$refs.paymentruleFormRef2;
            if (!formEl) return;
            formEl.validate((valid) => { if (valid) this.submitpayment2(); });
        },
        submitpayment2() {
            let currentObj = this;
            currentObj.loading2 = true;
            axios.post('/enquiry/addcustomerrefundpayment?id='+this.enquiry.id, this.paymentform2).then(function () {
                toastr.success('Refund Saved Successfully.');
                currentObj.$emit("saved");
                currentObj.paymentform2.paid_on = ''; currentObj.paymentform2.paid_by = '';
                currentObj.paymentform2.payment_details = ''; currentObj.paymentform2.amount = '';
                currentObj.paymentform2.payment_source = ''; currentObj.paymentform2.payment_status = '';
                currentObj.paymentform2.payment_id = '';
                currentObj.loading2 = false; currentObj.dialogAdd2 = false;
            }).catch(function (error) {
                if (error.response && error.response.status == "404") { toastr.error(error.response.data); }
                else { toastr.error('Something wrong, try again.'); }
                currentObj.loading2 = false;
            });
        },
        addattachment2(id) { this.attachmentform2.payment_id = id; this.attachmentform2.imagedata = ''; this.dialogAttachment2 = true; },
        pasteImage2(pasteEvent) {
            const items = pasteEvent.clipboardData && pasteEvent.clipboardData.items;
            if (!items) return;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf("image") === -1) continue;
                this.addImageCustomerPayment2(items[i].getAsFile());
            }
        },
        addImageCustomerPayment2(file) {
            if (!file || !file.type.match('image.*')) return;
            const reader = new FileReader();
            reader.onloadend = () => { this.attachmentform2.imagedata = reader.result; };
            reader.readAsDataURL(file);
        },
        submitPAForm2() {
            const formEl = this.$refs.attachmentruleFormRef2;
            if (!formEl) return;
            formEl.validate((valid) => { if (valid) this.uploaddocument2(); });
        },
        uploaddocument2() {
            let currentObj = this;
            axios.post('/enquiry/addcustomerrefundpaymentattachment?id='+this.enquiry.id, this.attachmentform2).then(function () {
                toastr.success('Attachment Saved Successfully.');
                currentObj.$emit("saved"); currentObj.uploading2 = false; currentObj.dialogAttachment2 = false;
            }).catch(function () { toastr.error('Something wrong, try again.'); currentObj.uploading2 = false; });
        },
        editpayment2(temppayment) {
            this.paymentform2.paid_on = moment(temppayment.paid_on, "DD-MM-YYYY").format('YYYY-MM-DD');
            this.paymentform2.paid_by = temppayment.paid_by;
            this.paymentform2.payment_details = temppayment.payment_details;
            this.paymentform2.amount = temppayment.amount;
            this.paymentform2.payment_source = temppayment.payment_source;
            this.paymentform2.payment_status = temppayment.payment_status;
            this.paymentform2.payment_id = temppayment.id;
            this.dialogAdd2 = true;
        },
        deletepayment2(payment) { this.deletePayment2 = payment; this.dialogDelete2 = true; },
        deletepaymentsubmit2() {
            let currentObj = this;
            currentObj.deleting2 = true;
            axios.post('/enquiry/deletecustomerrefundpayment', { id: this.deletePayment2.id }).then(function () {
                toastr.success('Refund Deleted Successfully.');
                currentObj.$emit("saved"); currentObj.deleting2 = false; currentObj.dialogDelete2 = false;
            }).catch(function () { toastr.error('Something wrong, try again.'); currentObj.deleting2 = false; });
        }
    }
}
</script>

<style scoped>
</style>
